<template>
	<div class="item_sidebar select-product-panel">
		<div class="inner_box with_select">
			<div class="title">Product</div>
		</div>

		<div>
			<span>
				Select a product to be connected to the order bump element.
			</span>
		</div>

		<div class="layout-row flex margin-t-10">
			<v-select class="flex small"
								:options="sortedProducts"
			          v-model="value"
			          @input="inputChanged"
			          label="name"
			          :reduce="x=>x.id"
			          :searchable="true"
			          :clearable="true"
			          append-to-body>
				<template v-slot:option="option">
					<div class="flex layout-row product-panel-entry">
						<span v-if="option.is_ob" class="is-ob-tag">OB</span>
						<span class="flex name">
						{{ option.name }}
					</span>
					<span class="price">
						{{ getPrice(option) }}
					</span>
					</div>
				</template>
				<template v-slot:selected-option="option">
					<div class="flex layout-row product-panel-entry selected">
						<span v-if="option.is_ob" class="is-ob-tag">OB</span>
						<span class="flex name">
						{{ option.name }}
					</span>
					</div>
				</template>
			</v-select>

			<v-button class="manage-btn" v-tippy content="Manage products"
			          label="Manage..." slim border @click="open=!open" />
		</div>


		<portal to="popup">
			<products-list-panel v-if="open" @close="open=false" :step="step" :products="products" />
		</portal>
	</div>
</template>

<script>
import VButton from '@/components/base/v-button';
import ProductsListPanel from '@/views/funnels/funnel-plus/steps/products/products-list-panel'
import {getPriceBrief} from "@/helpers/products";
import {mapGetters} from "vuex";

export default {
	name: 'selectProduct',
	props: ['title', 'value', 'options'],
	components: {VButton, ProductsListPanel},
	data: function () {
		return {
			open: false,
		}
	},
	computed: {
		...mapGetters(['getFunnelStore']),
		products(){
			return this.$store.state.page.products;
		},
		sortedProducts() {
			function compare(a, b) {
				if (a['order_index'] < b['order_index']) return -1;
				if (a['order_index'] > b['order_index']) return 1;
				return 0;
			}
			let orderbumps = this.products.filter(x=>x.is_ob).sort(compare);
			let other = this.products.filter(x=>!x.is_ob).sort(compare);
			return [...orderbumps, ...other];
		},
		step(){
			return this.$store.state.page.step;
		},
		funnelId(){
			return this.$store.state.page.initial.funnel;
		},
		stepId(){
			return this.$store.state.page.initial.step;
		},
		currencyCode(){
			return this.getFunnelStore ? this.getFunnelStore.currency_code : 'USD';
		},
	},
	methods: {
		getPrice(product) {
			return getPriceBrief(product,this.currencyCode)
		},
		inputChanged(){
			this.$emit('updated', this.value);

		}
	},
	created() {

	}
}
</script>
<style lang="scss">
.product-panel-entry {
	.name {
		white-space: normal;
	}
	.price {
		font-weight: 500;
	}
	.is-ob-tag {
		background: #ffb63a;
		color: #725825;
		border-radius: 5px;
		padding: 2px 6px;
		font-weight: 500;
		font-size: 11px;
		margin: auto 5px auto auto;
	}
	&.selected {
		overflow: hidden;
		.name {
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
	}
}
</style>
<style lang="scss" scoped>
.select-product-panel {
	.manage-btn {
		padding: 2px 5px;
		margin-left: 4px;
	}
	.button {
		text-wrap: none;
		white-space: nowrap;
	}
}
</style>
